import React from 'react';

export const notificationPagesConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/notification/overview',
        component: React.lazy(() => import('./Pages/overview')),
      },
    ],
  },
];
